import { Language } from '../../../dto/language';
import { QuizStep, QuizMode } from '../../../dto/user-words';
import { MakeReactive, noopMakeReactive } from '../../make-reactive';
import { IQuizzService } from '../../../services/i-quizz-service';

/**
 * Abstract view model for quiz data.
 * Framework-agnostic view model that manages quiz question loading.
 */
export abstract class IQuizViewModel {
	constructor(
		protected readonly quizzService: IQuizzService,
		protected readonly userId: string | undefined,
		protected readonly nativeLanguage: Language,
		protected readonly learnedLanguage: Language,
		protected readonly mode: QuizMode,
		protected readonly articleTranslationId?: string,
		protected readonly maxSteps?: number,
		protected readonly makeReactive: MakeReactive<unknown> = noopMakeReactive
	) {}

	// Abstract methods define the contract
	abstract isLoading(): boolean;
	abstract loadQuiz(): Promise<void>;
	abstract get steps(): QuizStep[];
	abstract get error(): string;
	abstract clearCache(): void;
}
